import "twin.macro";

import makeRadioOptionsFilter from "../components/makeRadioOptionsFilter";
import { useFilterContext } from "../filterContext";

const useOptions = () => {
  const { getValues } = useFilterContext();
  const hasBeacons = getValues("hasBeacons");
  return [
    { id: "true", name: "Has Beacons" },
    ...(hasBeacons ? [{ id: "false", name: "All" }] : []),
  ];
};

const FilterHasBeacons = makeRadioOptionsFilter({
  name: "hasBeacons",
  useOptionsHook: useOptions,
  title: "Has Beacons",
  chipTitlePrefix: "",
  popperTitleText: "PO Beacon Status",
});

export default FilterHasBeacons;
